import {NgModule} from '@angular/core';
import {NavComponent} from './nav.component';
import {SharedModule} from "../../common/shared.module";
import {TranslocoModule} from "@ngneat/transloco";
import {OverviewModule} from "../../containers";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

@NgModule({
  declarations: [
    NavComponent
  ],
  imports: [SharedModule, TranslocoModule, OverviewModule],
  exports: [
    NavComponent
  ]
})
export class NavModule {
}
